<template lang="pug">
  div
    order-step(:current-step="4")
    h2 Zahlung
    div.px-4.py-4
      div Die für Sie eingerichtete Zahlungsart:
      form.my-3(@submit.prevent)
        div.form-group.form-check.fat-checkbox
          input.form-check-input(type="radio" id="agree" checked)
          label.form-check-label(for="agree")
            | Ihre vereinbarten Zahlungsbedingungen mit der MALU WILZ Beauté GmbH
    order-notes
    div.card-footer.text-right(v-if="orderSummary")
      span.mb-2.d-flex.flex-wrap.justify-content-end
        span.no-wrap(v-if="customer && customer.studentProducts === 1") Preis:&nbsp;
          strong.no-wrap {{ orderSummary.totalPriceB2c }}
        span.no-wrap(v-else) Preis:&nbsp;
          strong.no-wrap {{ orderSummary.totalPriceB2b }}
        span.mx-2 &middot;
        span.no-wrap Menge:&nbsp;
          strong.no-wrap {{ orderSummary.totalQuantity }}
        span.mx-2 &middot;
        span.no-wrap {{ discountLabel }}:&nbsp;
          strong.no-wrap {{ orderSummary.onlineDiscount }}
        span.mx-2 &middot;
        span.no-wrap Versand:&nbsp;
          strong.no-wrap {{ orderSummary.shippingCosts }}
        span.mx-2 &middot;
        span.no-wrap {{ orderSummary.vatPercentage }}:&nbsp;
          strong.no-wrap {{ orderSummary.vat }}
        span.mx-2 &middot;
        span.no-wrap Gesamt:&nbsp;
          strong.no-wrap {{ orderSummary.totalPrice }}
      button.mr-2.btn.btn-secondary(
        type="button"
        @click="goBack"
        )
        | Zurück
      button.btn.btn-primary.btn-lg(
        type="button"
        @click="showConfirmation"
        )
        | Weiter
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import OrderStep from '@/components/orderForm/orderStep'
import OrderNotes from '@/components/orderForm/orderNotes'

export default {
  name: 'DeliveryAddress',
  components: {
    OrderNotes,
    OrderStep
  },
  computed: {
    ...mapState('orderForm', [
      'orderSummary'
    ]),
    ...mapGetters('authentication', [
      'customer'
    ]),
    discountLabel () {
      return this.customer && this.customer.studentProducts === 1
        ? 'Schüler-Rabatt 10%'
        : 'Online-Rabatt 3%'
    }
  },
  methods: {
    ...mapActions('ui', [
      'goBack',
      'showConfirmation'
    ])
  }
}
</script>

<style lang="stylus" scoped>
  .spinner
    width 64px
    height 64px
    position absolute
    top 200px
    left calc(50% - 32px)

    &.spinner-border
      border 0.25em solid currentColor
      border-right-color transparent

</style>
